import { useState, useEffect } from "react";

const POLL_MS = 45000;

export function useLmStudioLive(pollMs = POLL_MS) {
  const [live, setLive] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const res = await fetch("/api/lmstudio-status", {
          method: "GET",
          cache: "no-store",
        });
        const data = await res.json().catch(() => ({}));
        if (!cancelled) {
          setLive(Boolean(data?.live));
          setChecking(false);
        }
      } catch {
        if (!cancelled) {
          setLive(false);
          setChecking(false);
        }
      }
    };

    check();
    const id = setInterval(check, pollMs);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [pollMs]);

  return { live, checking };
}
